function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewLogo = function SvgNewLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 98 76",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-38092.9,-1935.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.80131,0,0,16.7578,37607.6,1418.46)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.533333,0,0,0.0573287,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M556.01,560.17C540.367,560.17 527.666,572.87 527.666,588.513C527.666,604.157 540.367,616.857 556.01,616.857C571.653,616.857 584.353,604.157 584.353,588.513L572.353,588.513C572.353,597.534 565.03,604.857 556.01,604.857C546.989,604.857 539.666,597.534 539.666,588.513C539.666,579.493 546.989,572.17 556.01,572.17L556.01,560.17ZM606.61,588.513C606.61,560.539 583.898,537.827 555.923,537.827C527.948,537.827 505.236,560.539 505.236,588.513L517.236,588.513C517.236,567.162 534.571,549.827 555.923,549.827C577.275,549.827 594.61,567.162 594.61,588.513L606.61,588.513Z",
    style: {
      fill: "rgb(55,175,173)"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-logo.5dfbcfcf.svg";
export { ForwardRef as ReactComponent };